import { render, staticRenderFns } from "./word_1.vue?vue&type=template&id=cc03c676&scoped=true"
import script from "./word_1.vue?vue&type=script&lang=js"
export * from "./word_1.vue?vue&type=script&lang=js"
import style0 from "./word_1.vue?vue&type=style&index=0&id=cc03c676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc03c676",
  null
  
)

export default component.exports